import React from "react";
import { connect } from "react-redux";
import Moment from "moment"
import LoadingOverlay from "./LoadingOverlay";
import { Popup, List } from "devextreme-react";
import NavBar from "devextreme-react/ui/nav-bar";
import DataGrid, { Column } from "devextreme-react/ui/data-grid";
import LoadingGif from "../../images/animacion2[18].gif";
import UserInfoColumn from "./UserInfoColumn";

class ModalVer extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      indexModal: 0,
      popupVisible: false
    };    
  }

  contenGeneralInfo = () => {
    if(!this.props.data) return ""
    if(this.props.data && !this.props.data.info) return ""
    const {
      CompanyName,
      CostCenter,
      PetitionerName,
      PetitionerRut,
      ProposalDate,
      ProposalDateEnd,
      WorkersQuota,
      RequestTypeDescription,
    } = this.props.data.info;
    return <React.Fragment>      
      <div
        className="row"
        style={{
          margin: "10px 0 10px 0",
          borderTop: "1px solid #ddd",
          paddingTop: 10,
        }}
      >
      </div>
      <div className="row">
        <div className="col-3">Empresa solicitante: </div>
        <div className="col-9" style={{ fontWeight: "bold" }}>{CompanyName}</div>
      </div>
      <br />
      <div className="row">
        <div className="col-3">Centro de costos: </div>
        <div className="col-9" style={{ fontWeight: "bold" }}>{CostCenter}</div>
      </div>
      <br />
      <div className="row">
        <div className="col-3">Solicitante: </div>
        <div className="row" style={{ paddingLeft: 14 }}>
          <div className="col-9" style={{ fontWeight: "bold" }}>{PetitionerName}</div>
          <div className="col-9">{PetitionerRut}</div>
        </div>
      </div>
      <br />
      <div className="row">
        <div className="col-3">Fecha preferente: </div>
        <div className="col-9">{Moment(ProposalDate).format("DD/MM/YYYY") + ("  -  " + Moment(ProposalDateEnd).format("DD/MM/YYYY"))}</div>
      </div>
      <br />
      <div className="row">
        <div className="col-3">Trabajadores: </div>
        <div className="col-9">{WorkersQuota}</div>
      </div>
      <br />
      <div className="row">
        <div className="col-3">Tipo de evaluación: </div>
        <div className="col-9">{RequestTypeDescription}</div>
      </div>
      <br />
      <div className="row">
        <div className="col-3">Centro de atención: </div>
        <div className="col-9">{this.props.data.defaultCityDescription ? this.props.data.defaultCityDescription : ""}</div>
      </div>
      <br />
    </React.Fragment>
  }

  contentBenefits = () => {
    if(!this.props.data) return ""
    const { benefits } = this.props.data
    if(!benefits) return "";
    return (
      <React.Fragment>
        <List
          className="listPoolsExams"
          dataSource={benefits}
          height="100%"
          grouped
          collapsibleGroups
          focusStateEnabled={false}
          scrollingEnabled
          hoverStateEnabled={false}
          groupRender={(item) =>
            <div>{item.key}</div>
          }
          onContentReady={(c) => {
            for (let i = 0; i < benefits.length; i++) { c.component.collapseGroup(i); }
          }}
        />
      </React.Fragment>
    )
  }

  contentWorkers = () => {
    if(!this.props.data) return ""
    const { workers } = this.props.data
    if(!workers) return "";
    return (
      <React.Fragment>
        <DataGrid
          dataSource={workers}
          showBorders={false}
          showColumnLines={false}
          showRowLines={false}
          className="custom-table"
          noDataText="Sin Trabajadores"
          rowAlternationEnabled
          hoverStateEnabled
          onSelectionChanged={this.handleSelection}          
          loadPanel={{
            enabled: true,
            showPane: true,
            showIndicator: true,
            indicatorSrc: LoadingGif,
            text: "Cargando...",
          }}
          paging={{
            pageSize: 20,
          }}
          pager={{
            showInfo: true,
            visible:true,
            infoText: (page, total, items) => `Página ${page} de ${total} (${items} resultados)`
          }}
        >
          <Column
            caption="Trabajador"
            allowFiltering
            allowSearch={false}
            cellComponent={(row) => {              
              if(!row.data.DocumentNumber){
                return (<UserInfoColumn
                  rut={""}
                  nombre={"SIN NOMBRE"}
                />)
              }else{
                return (
                <UserInfoColumn
                  rut={row.data.DocumentNumber ? row.data.DocumentNumber : ""}
                  nombre={row.data.Name ? row.data.Name : ""}
                />)
              }              
            }}
          />
          <Column
            dataField="Phone"
            caption="Teléfono"
            allowFiltering={false}
            allowSearch={false}
            alignment="center"
          />
          <Column
            dataField="Mail"
            caption="Mail"
            allowFiltering
            allowSearch={false}
            alignment="center"
          />
          <Column
            dataField="Date"
            caption="Fecha de agendamiento"
            allowFiltering
            allowSearch={false}
            alignment="center"
            dataType={'date'}
            format='dd/MM/yyyy HH:mm'  
          />
        </DataGrid>
      </React.Fragment>
    );
  }

  checkItem = (e) => {
    this.setState({indexModal: e.itemIndex})
  }
  
  render() {
    return (
      <Popup
        className={'modalVer'}
        visible={this.props.isOpen}
        onHiding={this.props.close}
        dragEnabled={false}
        closeOnOutsideClick={true}
        height={500}
        width={600}
        showTitle
        showCloseButton
        title="Ver solicitud"
      >
        <React.Fragment>
          {this.props.isLoading && <LoadingOverlay />}
          <NavBar
            dataSource={["Información general", "Baterías/Prestaciones", "Trabajadores"]}
            selectionMode="single"
            onItemClick={this.checkItem}
            className="header-tabs edit-roles-tabs"
            noDataText="Sin acceso"
            selectedIndex={this.state.indexModal}
          />
          <div>
            {this.state.indexModal === 0 && this.contenGeneralInfo()}
            {this.state.indexModal === 1 && this.contentBenefits()}
            {this.state.indexModal === 2 && this.contentWorkers()}
          </div>
          
        </React.Fragment>          
      </Popup>        
    );
  }
}

const mapStateToProps = (state) => ({  
  
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalVer);

